import { render, staticRenderFns } from "./staticListByTable.vue?vue&type=template&id=4f2ae52a&"
import script from "./staticListByTable.vue?vue&type=script&lang=js&"
export * from "./staticListByTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/staticListByTable.vue"
export default component.exports